import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import Chip from '../../Generic/Chip';
import { Button } from '../../Generic/Button';

import styles from './ProductList-tw-styles';

class ProductActiveFilter extends React.Component {
  render() {
    let { filters, clearFilter, pageFacet } = this.props;

    return (
      <div className={classNames(styles.activeFilter.mainWrapper)}>
        <div className={classNames(styles.activeFilter.filterWrapper)}>
          {filters.map(
            fc =>
              fc.title.trim() !== (pageFacet && pageFacet.title) && (
                <span
                  key={fc.id}
                  className={classNames(styles.facet.chipWrapper)}
                >
                  <Chip
                    component="span"
                    onDelete={() => clearFilter(fc, fc)}
                    label={fc.title && fc.title.trim()}
                    deleteIcon={
                      <Button
                        type="button"
                        aria-label={fc.title?.trim().toUpperCase() === 'WAVY' 
                          ? `remove WAVY from active filter`
                          : `remover ${(fc.title || '').trim()} do filtro ativo`}
                        className={classNames(styles.facet.chipCloseBtn)}
                      >
                        <span className={styles.dialog.closeSpan}>×</span>
                      </Button>
                    }
                    className={classNames(styles.facet.chip)}
                    labelStyle={classNames(styles.facet.chipLabel)}
                  />
                </span>
              )
          )}
        </div>
      </div>
    );
  }
}

ProductActiveFilter.propTypes = {
  filters: PropTypes.oneOfType([PropTypes.array]).isRequired,
  clearFilter: PropTypes.func.isRequired,
  pageFacet: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

ProductActiveFilter.defaultProps = {};

export default observer(ProductActiveFilter);
